<template>
  <div>
    <SplashScreen v-if="!initialized" />
    <div v-else class="App">
      <notifications />
      <transition name="menu">
        <Menu v-if="isLoggedIn && showSidebar" />
      </transition>
      <router-view :key="$route.fullPath" />
      <template v-if="isLoggedIn">
        <footer class="Footer">
          <div class="Section">
            <router-link :to="{name: 'Home'}" class="Brand">
              <!-- <div class="Brand__logo">Captain<span>Vin</span></div> -->
              <img src="./assets/images/logo.svg" alt="Logo Captain Vin" width="152" />
            </router-link>
            <Navigation />
          </div>
        </footer>
        <div class="Section">
          <p class="warning">L'abus d'alcool est dangereux pour la santé. À consommer avec modération.</p>
          <router-link class="cgu-link" :to="{ name: 'CGU'}" target="_blank">Conditions Générales de Vente</router-link>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import store from "./store";
import SplashScreen from "./views/SplashScreen";
import EventBus from "./event-bus";
import Navigation from "@/components/Navigation";
import Menu from "@/components/Menu";

export default {
  name: "App",
  data: () => ({
    showSidebar: false,
    ready: false
  }),

  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState(["initialized"])
  },
  watch: {
    "$route": {
      handler(to, from) {
        document.title = to.meta.title ? `${to.meta.title} - Captain Vin` : "Captain Vin";
      },
      immediate: true
    }
  },

  created: function() {
    EventBus.$on("toggleSidebar", () => {
      this.showSidebar = !this.showSidebar;
    });

    this.$http.interceptors.response.use(undefined, ({ response }) => new Promise((resolve, reject) => {
      if (response.status === 401 && response.config && !response.config.__isRetryRequest) {
        store.dispatch("auth/logout");
        store.commit("cart/resetCart");
      }

      if (response.status === 404) {
        this.$router.replace({ name: "NotFound" });

        return;
      }

      if (response.status !== 500 && response.data) {
        throw response.data;
      }

      throw new Error("Erreur inattendue");
    }));
  },

  components: { Menu, SplashScreen, Navigation }

};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.App {
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  justify-content: flex-start;
}

.cgu-link,
.warning {
  display: block;
  text-align: center;
  color: $color-black;
  font-size: 0.875em;
}

.warning {
  font-style: italic;
}

.menu-enter-active,
.menu-leave-active {
  transition: all 0.16s ease-in-out;
}

.menu-enter,
.menu-leave-to {
  transition: 0.05s;
  opacity: 0;
  transform: translate(-90%);
}

.Footer {
  margin-top: auto; // push to the bottom of .App (100vh) if no content
  padding: $global-margin 0;
  background-color: $color-black;
  color: #fff;

  & > .Section {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-flow: column;
    gap: $global-margin;
  }

  .Brand {
    order: 1;
    display: inline-block;
    margin-left: 0;
    border: 1px solid #fff;
  }

  &__baseline {
    font-style: italic;
  }
}

@media (min-width: 900px) {
  .Footer > .Section {
    flex-flow: row;
  }

  .Footer .Brand {
    order: 0;
    margin-top: 2*$global-margin;
  }
}
</style>
